import { render, staticRenderFns } from "./pi-bindnum-detail.vue?vue&type=template&id=6abb7c92"
import script from "./pi-bindnum-detail.vue?vue&type=script&lang=ts"
export * from "./pi-bindnum-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports